export default "__VITE_ASSET__DOEMU3pu__"